// 全局自定义指令

/**
 * el-button节流指令
 * 使用方法 v-prevent-re-click="1000"
 * 默认两秒之内点击一次
 */
export const preventReClick = {
  created(el, binding) {
    el.addEventListener("click", () => {
      if (!el.disabled) {
        el.disabled = true;
        setTimeout(() => {
          el.disabled = false;
        }, binding.value || 2000);
      }
    });
  },
};

/**
 * 限制输入框只能输入数字的指令
 * 使用方法:
 * v-only-number  - 只能输入整数
 * v-only-number:2 - 可以输入小数，保留2位小数
 * v-only-number:3.decimal - 可以输入小数，保留3位小数
 * v-only-number:[decimalPlaces].decimal - 可以输入小数，保留指定位数
 */
export const onlyNumber = {
  mounted(el, binding) {
    // 获取小数位数
    let decimalPlaces = binding.arg || 0; // 默认不允许小数点
    if (binding.modifiers["decimal"]) {
      decimalPlaces = binding.value || 2; // 如果有 decimal 修饰符，则允许小数点，默认保留2位
    }

    // 获取实际的input元素
    const input = el.tagName.toLowerCase() === "input" ? el : el.querySelector("input");
    if (!input) return;

    // 保存最后一次有效的值
    let lastValidValue = "";

    // 处理输入事件
    input.addEventListener("input", function (event) {
      let value = event.target.value;
      let regex;

      if (decimalPlaces > 0) {
        // 允许数字和最多指定数量的小数位
        regex = new RegExp(`^\\d*(\\.\\d{0,${decimalPlaces}})?$`);
      } else {
        // 只允许整数
        regex = /^\d*$/;
      }

      if (!regex.test(value)) {
        // 如果输入不符合规则，回滚到上一次合法的值
        event.target.value = lastValidValue;
      } else {
        // 更新最后一次合法的值
        lastValidValue = value;
      }
    });

    // 处理失去焦点事件
    input.addEventListener("blur", function (event) {
      let value = event.target.value;
      if (value && decimalPlaces > 0) {
        // 确保小数点后的位数不超过指定的数量
        const formattedValue = parseFloat(value).toFixed(decimalPlaces);
        event.target.value = formattedValue;
        lastValidValue = formattedValue;
      }
    });
  },
};
